module.exports = __webpack_public_path__ + "img/avatar2.241aea51.png";